import { render } from "./SettingsMaintenance.vue?vue&type=template&id=2ca0af9c"
import script from "./SettingsMaintenance.vue?vue&type=script&lang=js"
export * from "./SettingsMaintenance.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__